import { createStorage } from 'unstorage';
import memoryStorageDriver from "unstorage/drivers/memory";

export const catalogScrollPosStorageClient = createStorage({
  driver: memoryStorageDriver()
});
